import { useState, useCallback, useMemo } from 'react';
import { useCreateIntersectionObserverRefs } from '../../../hooks/useCreateIntersectionObserverRefs.js';

const convertHiddenItemsObjectToSortedByKeyArray = (hiddenItems) => Object.keys(hiddenItems)
    .sort()
    .map((key) => hiddenItems[key]);
const useHiddenTopLinksObserver = (props) => {
    const [hiddenItems, setHiddenItems] = useState({});
    const [visibleEntries, setVisibleEntries] = useState({});
    const handleChange = useCallback(({ inView, item, index, entry }) => {
        if (inView) {
            setHiddenItems((hiddenItems) => {
                const { [`${index}`]: _, ...rest } = hiddenItems;
                return rest;
            });
            setVisibleEntries((visibleEntries) => ({ ...visibleEntries, ...(entry ? { [String(index)]: entry } : {}) }));
        }
        else {
            setHiddenItems((hiddenItems) => ({ ...hiddenItems, [String(index)]: item }));
            setVisibleEntries((visibleEntries) => {
                const { [`${index}`]: _, ...rest } = visibleEntries;
                return rest;
            });
        }
    }, []);
    const lastRightVisibleEntry = useMemo(() => Object.keys(visibleEntries)
        .sort()
        .map((key) => visibleEntries[key])
        .pop(), [visibleEntries]);
    const { refs, getRefKey } = useCreateIntersectionObserverRefs({
        ...props,
        onChange: handleChange,
    });
    return {
        refs,
        getRefKey,
        lastRightVisibleEntry,
        hiddenItems: convertHiddenItemsObjectToSortedByKeyArray(hiddenItems),
    };
};

export { useHiddenTopLinksObserver };
//# sourceMappingURL=useHiddenTopLinksObserver.js.map
